import React, {useState} from "react";
import IconButton from '@mui/material/IconButton';
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import IconButtonSetting from "../../../../../../../components/Button/IconButtonSetting";

import { Fam_TableData } from "./Get_Fam_table";


export default function Fam_Variants() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      

<IconButton onClick={handleOpen} size="small" >
            <IconButtonSetting />
</IconButton>

<CustomDialog open={open} onClose={handleClose}

title='Familial hypercholesterolemia (FH) - Variants'

content={ <Fam_TableData />}

/>

</>
)}